export default (response = {}, isDesktop = false) => {
    const {options = []} = response && response.data && response.data.detail || {};
    const obj = {};
    options.forEach(({ans_text: text = ""}) => {
        const formattedText = text.split(" ").join("_").toUpperCase();
        obj[formattedText] = text;
    });
    response.data.detail = obj;
    if (isDesktop) return obj;
    else return response;
};
